import React from 'react';
import { capitalize } from 'lodash';
import { getOrgTermsContent } from '../../../content/utils.js';
import { NoRoleIcon } from '../../icons/NoRoleIcon.jsx';
import CustomTooltip from '../../CustomTooltip.jsx';

const UserSubHeaderInfo = ({ user }) => {
  return (
    <div className="flex flex-align-stretch">
      {user.status === 'no_roles' ? (
        <CustomTooltip
          tooltip={
            <div style={{ maxWidth: '300px' }}>
              <strong>
                <h5
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '20px',
                    color: '#153142',
                  }}
                  className="m-b-8"
                >
                  This User doesn’t have any Role in your Organization,{' '}
                  {getOrgTermsContent('project')} or Group.
                </h5>
              </strong>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: '400',
                  lineHeight: '20px',
                  color: '#7F8FA4',
                }}
                className="m-b-0 text-muted"
              >
                An invitation to join ChangeSync will be sent after at least one
                role is assigned on the Permissions tab.
              </p>
            </div>
          }
          id="tooltip"
        >
          <div className="profile-avatar  m-r-10">
            <img src={user.avatar} alt="avatar" />
            <div className="no-roles current-user">
              <NoRoleIcon />
            </div>
          </div>
        </CustomTooltip>
      ) : (
        <div className="profile-avatar m-r-10">
          <img src={user.avatar} alt="avatar" />
        </div>
      )}
      <div className="flex flex-col flex-center flex-align-start">
        <h2
          className={`${user.status !== 'no_roles' ? 'm-b-12' : 'flex-center'}`}
        >
          {user.fullName}
        </h2>

        <div className="flex">
          {user.status !== 'no_roles' ? (
            <div>
              <strong className="text-muted">Status:</strong>
              <span className={`label label-status-${user.status} m-l-12`}>
                {capitalize(user.status)}
              </span>
            </div>
          ) : null}
          {user.invitedAt && user?.status === 'invited' ? (
            <strong className="text-muted m-l-10">{user.invitedAt}</strong>
          ) : null}

          {user.orgRole ? (
            <div className="m-l-12">
              <span className="divider text-muted">|</span>
              <strong className="text-muted m-l-12">Organization Role:</strong>
              <span className={`label label-status-${user.orgRole} m-l-12`}>
                {capitalize(user.orgRole)}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default UserSubHeaderInfo;
